fourToldApp.controller("indexCntrl", function(xmppAuth, Idle, session, $location, $scope, services, $sce, $mdDialog, $cookieStore, $window, theme, $remember, $uibModal, $localStorage, $timeout) {
    $scope.user = {};
    $scope.hora = undefined;
    $scope.msg = undefined;
    $scope.user = services.user.getData();
    $scope.theme = theme.getTheme();
    
    var date = new Date();
    var str = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " +  date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
//Idle config timers
    var SHOWING_DELTA = 30;
    let SEND_AGA_PRESENCE_TIME = 4 * 60 * 1000;
    var sessionTimeOutMin = $localStorage.sessionTimeOutMin || 15 * 60;
    console.log("sessionTimeOutMin: " + sessionTimeOutMin)
    var alertTime = sessionTimeOutMin - SHOWING_DELTA;
    Idle.watch();
    Idle.setIdle(alertTime); 
    $scope.started = true; 
     
    window.onpagehide = function(e) {
        console.log("pagehide: borrower was removed" )
        $scope.logout()
       
    }

    window.onblur = function (e) {
        var date = new Date; 
        var seconds = date.getSeconds();
        var minutes = date.getMinutes();
        var hour = date.getHours();
        console.log(hour + " : " + minutes + " : " + seconds)
        console.log("onblur") 
        $localStorage.windowStatus = "background"
    }

    window.onfocus = function (e) {
        console.log("onfocus") 
        var connectStatus = $localStorage.isDisconnected 
        var isDiconnected = connectStatus == "1"
        if(isDiconnected) {
            console.log("isDiconnected")           
        }             
    }



    function sendAgapresence() { 
      var sendPresenceTimerid = setInterval(function() {
        console.log("sendAgapresence");
        xmppAuth.Chat.sendPresence();
      }, SEND_AGA_PRESENCE_TIME)
      
      localStorage.setItem("sendPresenceTimerid", sendPresenceTimerid)
    }
    sendAgapresence()

    $scope.profileUrl = "#profile";
    $scope.dashboardUrl = "#dashboard";
    $scope.loanListUrl = "#loanList";
    $scope.changepasswordUrl = "#change-password-section";
    $scope.guarantosUrl = "#guarantor";
    var isAgent =  window.sessionStorage.getItem('mode') == 'asesorweb' ? true:false;

  if ($window.sessionStorage.getItem("urlTag") != null) {
      $scope.profileUrl = $scope.profileUrl + $window.sessionStorage.getItem("urlTag");
      $scope.dashboardUrl = $scope.dashboardUrl + $window.sessionStorage.getItem("urlTag");
      $scope.loanListUrl = $scope.loanListUrl + $window.sessionStorage.getItem("urlTag");
      $scope.changepasswordUrl = $scope.changepasswordUrl + $window.sessionStorage.getItem("urlTag");
      $scope.guarantosUrl = $scope.guarantosUrl + $window.sessionStorage.getItem("urlTag");
      $scope.channelUrlTag = $window.sessionStorage.getItem("urlTag");
  }
  window.onpopstate = function (e) {
      window.history.forward(1);
  };

  if ($scope.user) {
      $scope.user.photo = services.user.getPhoto();
      $scope.user.logo = services.user.getLogo();
  }

  $window.onbeforeunload = function (event) {
      if ($window.localStorage.getItem("access_token1")) {
          return "You have made changes, but you did not save them yet.\nLeaving the page will revert all changes.";
      }
  };
    var confirm = undefined;  
    $scope.$watch("online", function (isConnected) {
        if (isConnected === false) {
            $("#inputSimple").prop("disabled", true);
            $("#stringInput").prop("disabled", true);
            $("#iconRetry").prop("disabled", true);
            $localStorage.disconnect = true;
            confirm = {template: '<md-dialog aria-label="internet" id="offline">' +
            '<md-dialog-content style="max-width:800px;max-height:810px; padding: 4%;">'+
                '<div layout="row">' +
                ' <div flex="30">' +
                    '<div layout="row" layout-sm="column" layout-align="space-around">'+
                    '<md-progress-circular md-mode="indeterminate" md-diameter="40"></md-progress-circular>'+
                    '</div>' +
                '</div>' +
                '<div flex="70">' +
                    ' <label for="" style="color:black">Conexión perdida, intentando conectarse</label>'+
                '</div>' +
                '</div>' +
            '</md-dialog-content>'+
            '</md-dialog>',
            parent: angular.element(document.body),
            clickOutsideToClose:false};
            $mdDialog.show(confirm);
        } else if (isConnected === true && $localStorage.disconnect === true && confirm) {
            delete $localStorage.disconnect;
            $mdDialog.hide(confirm, "finished");
            confirm = undefined;
            $("#inputSimple").removeAttr("disabled");
            $("#stringInput").removeAttr("disabled");
            $("#iconRetry").removeAttr("disabled");
        }
    });

  $window.addEventListener(
      "storage",
      (event) => {
          if (event.storageArea == localStorage) {
              let token = window.localStorage.getItem("access_token1");
              if (token == null && xmppAuth.Chat.connected === true) {
                  console.log("desconectar porque se abrio otra sesion");
                  xmppAuth.Chat.disconnect();
                  session.logout();
              }
          }
      },
      false
    );

  $scope.$watch(
      function () {
          $scope.hora = $cookieStore.get("hora");
          $scope.msg = $window.sessionStorage.getItem("msg");
          return window.localStorage.getItem("userData");
      },
      function (newVal, oldVal) {
          $scope.user = services.user.getData();
          if ($scope.user) {
              $scope.user.photo = services.user.getPhoto();
              $scope.user.logo = services.user.getLogo();
          }
      }
  );

  $scope.cancel = function () {
      $mdDialog.cancel();
  };

  $scope.renderHtml = function (htmlCode) {
      if (htmlCode) {
          var text = htmlCode.replace(/<br\s*\/?>/gm, "\n");
          text = text.replace("<br/>", " ");
          return $sce.trustAsHtml(text);
      }
  };

  $scope.questionsDialog = function (ev) {
      if ($window.sessionStorage.getItem("needConfigureQuestions") === "true" && $window.localStorage.getItem("access_token1")) {
          $scope.quentions = services.configuration_securityQuentions("bearer " + $window.localStorage.getItem("access_token1")).getQuestions({}, {}, function (response) {
              if (response.code === 2 || response.data.length === 0) {
                  $window.sessionStorage.removeItem("needConfigureQuestions");
              } else {
                  $mdDialog.show({
                      locals: { dataToPass: response },
                      templateUrl: "security_questions.html",
                      parent: angular.element(document.body),
                      targetEvent: ev,
                      controller: "quentionsCntrl",
                      clickOutsideToClose: false,
                  });
              }
          });
      }
  };


  $scope.$on('IdleStart', function() {
    var date = new Date(); 
    var timeString = date.toString(); 
    console.log("IdleStart: " + timeString) 
    showIdleAlert();
  });

  $scope.$on('IdleEnd', function() {
    var date = new Date(); 
    var timeString = date.toString(); 
    console.log("IdleEnd: " + timeString)  
  });
  $scope.$on('IdleTimeout', function() { 
    var date = new Date(); 
    var timeString = date.toString(); 
    console.log("IdleTimeout" + timeString) 
});        

function timeUp() {  
    $uibModal.open({
        animation: false,
        controller: modalController,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template:   '<div>'+
                        '<div layout="row" layout-align="center center" style="padding-top:5%; font-size:18px; color: black;">'+
                          '{{session_label_expired}}'+
                        '</div>'+
                        '<div layout="row" layout-align="center center">'+
                            '<md-button class="md-primary" type="button" ng-click="hide()">OK</md-button>'+
                        '</div>'+
                    '</div>',
        size: 'sm'
    });
    Idle.unwatch();  
    $scope.logout();
  }
  
  function showIdleAlert() {

    if($location.search().offline) {
        return
    } 
    var ev = {};
    var  alertTimerid = localStorage.getItem("alertTimerid");
    clearInterval(alertTimerid);
    $mdDialog.show({
      controller: 'AlertTimeSession',
      templateUrl: '/views/dashboard/timeup.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function(answer) {
        if(answer == false) {
          timeUp()
        } 
      }, function() {
          $scope.disabledBtn = false;
    });

  }
  function modalController($scope, $uibModalInstance, theme) {
      $scope.session_label_expired = theme.getTheme() &&  theme.getTheme().session_label_expired ? theme.getTheme().session_label_expired : 'Su sesión  ha expirado';
      $scope.hide = function () {
          $uibModalInstance.close();
      };
  }
  
  var showAlert = true;
  $scope.$on('agaUserDisconnected', function() {
      console.log("agaUserDisconnected");
      if(showAlert === true) {   
        showAlert = false;     
        $uibModal.open({
          animation: false,
          controller: modalController,
          ariaLabelledBy: 'modal-title',
          ariaDescribedBy: 'modal-body',
          template:   '<div class="modal-dialog-idle">'+
                          '<div layout="row" layout-align="center center" style="padding-top:5%; font-size:18px; color: black;">'+
                              'Ha habido un problema de conexión.'+
                          '</div>'+
                          '<div layout="row" layout-align="center center">'+
                              '<md-button class="md-primary" type="button" ng-click="hide()">OK</md-button>'+
                          '</div>'+
                      '</div>',
          size: 'sm'
        });
        Idle.unwatch();
        $scope.logout();
      
    }
  });

  
  $scope.logout = function () {
    $localStorage.windowStatus = "front"
    var token = $window.localStorage.getItem("access_token1");
    $location.search().identification = ""
    console.log("$scope.logout")
    $window.localStorage.removeItem("access_token1");
    services.logout("bearer " + token).post({}, {}, function (response) {
        
        if (!$remember("phoneNumber") && !$remember("password")) {
            $cookieStore.remove("password");
            $cookieStore.remove("phoneNumber");
        } 
                
        if($location.search().offline) {
          session.logout();
        } else {
          xmppAuth.Chat.connectionStatus = 0;
          xmppAuth.Chat.disconnect();
        }
        window.top.postMessage('success-logout-menu', '*')
    });
};
 

    $scope.toggleNavbar = function () {
      $(".leftside-navigation").niceScroll({
          cursorcolor: "#1FB5AD",
          cursorborder: "0px solid #fff",
          cursorborderradius: "0px",
          cursorwidth: "3px",
      });
      $("#sidebar").toggleClass("hide-left-bar");
      if ($("#sidebar").hasClass("hide-left-bar")) {
          $(".leftside-navigation").getNiceScroll().hide();
      }
      $(".leftside-navigation").getNiceScroll().show();
      $("#main-content").toggleClass("merge-left");

      if ($("#container").hasClass("open-right-panel")) {
          $("#container").removeClass("open-right-panel");
      }
      if ($(".right-sidebar").hasClass("open-right-bar")) {
          $(".right-sidebar").removeClass("open-right-bar");
      }

      if ($(".header").hasClass("merge-header")) {
          $(".header").removeClass("merge-header");
      }
      if ($("#main-content").hasClass("content-all")) {
        $("#main-content").removeClass("content-all");
        }
        else{
            $("#main-content").toggleClass("content-all");
        }
    };
    $scope.toggleNavbarOptions = function () {
        $("#navbarOptions").toggle("slide");
    };   
    if(isAgent && ($window.navigator.userAgent !== 'commerce-mobile')){
        $timeout(function () {
                if(document.getElementById('logobanner') && document.getElementById('iconbanner')){
                    var button = document.getElementById('logobanner');
                    button.style.display = "block";
                    var logo = document.getElementById('iconbanner')
                    logo.style.display = "none";
                }
                $("#sidebar").toggleClass("hide-left-bar");
                $("#main-content").addClass("content-all");
        }, 0);
    };
    $scope.hideMenu = $location.search()._managed == '2';

});

fourToldApp.controller("toggleNavbar", function ($scope, theme, $location, $window, $localStorage, $filter, $rootScope, $timeout) {
    $scope.theme = theme.getTheme();
    if ($window.sessionStorage.getItem("isAgentWebView") == "true") $scope.showHeader = false;
    else $scope.showHeader = true;

   $scope.toggleNavbarOptions = function () {
        $(".leftside-navigation").niceScroll({
            cursorcolor: "#1FB5AD",
            cursorborder: "0px solid #fff",
            cursorborderradius: "0px",
            cursorwidth: "3px",
        });
        $("#sidebar").toggleClass("hide-left-bar");
        if ($("#sidebar").hasClass("hide-left-bar")) {
            $(".leftside-navigation").getNiceScroll().hide();
        }
        $(".leftside-navigation").getNiceScroll().show();
        $("#main-content").toggleClass("merge-left");

        if ($("#container").hasClass("open-right-panel")) {
            $("#container").removeClass("open-right-panel");
        }
        if ($(".right-sidebar").hasClass("open-right-bar")) {
            $(".right-sidebar").removeClass("open-right-bar");
        }

        if ($(".header").hasClass("merge-header")) {
            $(".header").removeClass("merge-header");
        }
        if ($("#main-content").hasClass("content-all")) {
            $("#main-content").removeClass("content-all");
        }
        else{
            $("#main-content").toggleClass("content-all");
        }
    };

  $scope.channel = [];
  $scope.$on("msgChannel", function (event, data, type) {
      switch (type) {
          case "FINISH":
              $timeout(function () {
                  var index = $localStorage.channel.findIndex((item) => item.alternateChannelId === data.fromJabberId);
                  $localStorage.channel.splice(index, 1);
                  $location.path("/dashboard");
              }, 1000);
              break;
          default:
              $scope.safeApply(messageReceive(data));
      }
  });

  $scope.msgUnread = $localStorage.msgUnread;

  $scope.$on("msgUnread", function (event, id) {
      //Para el manejo de mensajes nuevos no leidos
      var split_channel = $location.path().split("/");
      var channel = $localStorage.channel.find((item) => item.alternateChannelId === id);
      if (id === "dashboard" && split_channel[1] !== "dashboard") {
          if (!$localStorage.msgUnread) $localStorage.msgUnread = 1;
          else $localStorage.msgUnread = $localStorage.msgUnread + 1;
          $scope.msgUnread = $localStorage.msgUnread;
          $scope.$apply();
      } else if (split_channel[1] !== "channel" && channel) {
          var channel = $localStorage.channel.find((item) => item.alternateChannelId === id);
          channel.unread = channel.unread + 1;
          $scope.$apply();
      } else if (split_channel[1] === "channel") {
          if ($localStorage.alternateChannelId !== id) {
              var channel = $localStorage.channel.find((item) => item.alternateChannelId === id);
              channel.unread = channel.unread + 1;
              $scope.$apply();
          }
      }
  });

  $scope.safeApply = function (fn) {
      var phase = this.$root.$$phase;
      if (phase === "$apply" || phase === "$digest") {
          if (fn && typeof fn === "function") {
              fn();
          }
      } else {
          this.$apply(fn);
      }
  };

  function messageReceive(data) {
      data.hour = $filter("date")(data.date, "h:mm a");
      $scope.channel.push(data);
      $localStorage.channel = $scope.channel;
  }

  if ($localStorage.channel) {
      $scope.channel = $localStorage.channel;
  }

  $scope.selectedIndex = $localStorage.selectedIndex;
  $scope.selectMenuItem = function (index) {
      if ($localStorage.selectedIndex !== index) {
          if ($scope.selectedIndex === null) {
              $scope.selectedIndex = index;
          } else if ($scope.selectedIndex === index) {
              $scope.selectedIndex = null;
          } else {
              $scope.selectedIndex = index;
          }
          $localStorage.selectedIndex = $scope.selectedIndex;
      }
  };
  $scope.redirectTo = function (name, id) {
      $localStorage.alternateChannel = name;
      $localStorage.alternateChannelId = id;
    }

    
});

fourToldApp.controller("AlertTimeSession", function($scope, $mdDialog, theme, $sce, $timeout) {
  var timerId = 0;
  $scope.time = 30;
  $scope.session_label_timer_prefix =   theme.getTheme() &&  theme.getTheme().session_label_timer_prefix ? theme.getTheme().session_label_timer_prefix : 'Su sesión expirará en';
  $scope.session_label_timer_suffix = theme.getTheme() &&  theme.getTheme().session_label_timer_suffix ? theme.getTheme().session_label_timer_suffix : undefined;
  $scope.session_label_timer_button = theme.getTheme() &&  theme.getTheme().session_label_timer_button ? theme.getTheme().session_label_timer_button : 'Continuar';
  $scope.hide = function() {
    var answer = true;
    clearTimeout(timerId);
    $mdDialog.hide(answer);
  };
  $scope.renderHtml = function(htmlCode) {
    if(htmlCode){
      var text = htmlCode.replace(/s*\/?>/mg, "\n");
      return $sce.trustAsHtml(htmlCode);
    }
  };
  $timeout(function() {
    document.getElementById('spanPrefix').innerHTML = $scope.session_label_timer_prefix +' '+ $scope.time + ' segundos.';
  },0);
  timerId = setInterval(function() {
    $scope.$apply(function() {
        $scope.time--; 
        document.getElementById('spanPrefix').innerHTML = $scope.session_label_timer_prefix +' '+ $scope.time + ' segundos.';
    });
    
    if($scope.time <= 0) {
      var answer = false;
      clearTimeout(timerId);
      $mdDialog.hide(answer);
    }
  }, 1000) 
})
fourToldApp.controller("msg_error_xmpp", function($scope, $mdDialog) {
    $scope.hide = function() {
      $mdDialog.hide();
  };

  $scope.cancel = function () {
      $mdDialog.cancel();
  };

  $scope.answer = function (answer) {
      $mdDialog.hide(answer);
  };
});
